<div class="early-bird-landing">
  <!-- Hero Section with Offer -->
  <div class="hero-section">
    <div class="hero-container">
      <div class="hero-content">
        <div class="offer-badge">
          <mat-icon>local_offer</mat-icon>
          <span>LIMITED TIME OFFER</span>
        </div>
        <h1>25% OFF Your First 3 Months!</h1>
        <p class="hero-subtitle">Professional pest control services in Northern Utah</p>
        <div class="offer-details">
          <mat-icon>schedule</mat-icon>
          <span>Offer expires April 30th, 2026</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="main-content">
    <div class="container">
      <div class="content-grid">
        <!-- Company Info -->
        <div class="company-info">
          <h2>Utah's Trusted Pest Control Experts</h2>
          <p class="company-description">
            Complete Pest Control has been protecting Northern Utah homes and businesses for over a decade. 
            Our licensed and insured technicians provide comprehensive pest management solutions using 
            eco-friendly methods that are safe for your family and pets.
          </p>

          <!-- Services Overview -->
          <div class="services-overview">
            <h3>Our Services Include:</h3>
            <div class="service-list">
              <div class="service-item">
                <mat-icon>bug_report</mat-icon>
                <div>
                  <h4>General Pest Control</h4>
                  <p>Comprehensive treatment for ants, spiders, wasps, and more</p>
                </div>
              </div>
              <div class="service-item">
                <mat-icon>home</mat-icon>
                <div>
                  <h4>Residential Services</h4>
                  <p>Protect your home with regular maintenance and treatments</p>
                </div>
              </div>
              <div class="service-item">
                <mat-icon>business</mat-icon>
                <div>
                  <h4>Commercial Services</h4>
                  <p>Keep your business pest-free with professional solutions</p>
                </div>
              </div>
              <div class="service-item">
                <mat-icon>eco</mat-icon>
                <div>
                  <h4>Eco-Friendly Options</h4>
                  <p>Safe, effective treatments that protect the environment</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Why Choose Us -->
          <div class="why-choose-us">
            <h3>Why Choose Complete Pest?</h3>
            <div class="benefits">
              <div class="benefit">
                <mat-icon>verified</mat-icon>
                <span>Licensed & Insured</span>
              </div>
              <div class="benefit">
                <mat-icon>schedule</mat-icon>
                <span>Flexible Scheduling</span>
              </div>
              <div class="benefit">
                <mat-icon>support_agent</mat-icon>
                <span>Local Utah Company</span>
              </div>
              <div class="benefit">
                <mat-icon>star</mat-icon>
                <span>10+ Years Experience</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Lead Form -->
        <div class="form-section">
          @if (!formSubmitted) {
            <mat-card class="offer-card">
              <mat-card-header>
                <mat-card-title>
                  <mat-icon>local_offer</mat-icon>
                  Claim Your 25% Discount!
                </mat-card-title>
                <mat-card-subtitle>
                  Get your free quote and save on your first 3 months
                </mat-card-subtitle>
              </mat-card-header>
              
              <mat-card-content>
                <form [formGroup]="leadForm" (ngSubmit)="onSubmitLead()" class="lead-form">
                  <mat-form-field appearance="outline">
                    <mat-label>Full Name</mat-label>
                    <input matInput formControlName="name" placeholder="Enter your full name">
                    <mat-icon matSuffix>person</mat-icon>
                    <mat-error>
                      @if (leadForm.get('name')?.touched && leadForm.get('name')?.errors) {
                        {{ getErrorMessage('name') }}
                      }
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>ZIP Code</mat-label>
                    <input matInput formControlName="zipCode" placeholder="Enter your ZIP code">
                    <mat-icon matSuffix>location_on</mat-icon>
                    <mat-error>
                      @if (leadForm.get('zipCode')?.touched && leadForm.get('zipCode')?.errors) {
                        {{ getErrorMessage('zipCode') }}
                      }
                    </mat-error>
                  </mat-form-field>

                  <div class="contact-method-section">
                    <mat-form-field appearance="outline">
                      <mat-label>Preferred Contact Method</mat-label>
                      <mat-select formControlName="contactPreference">
                        <mat-option value="TEXT">Text</mat-option>
                        <mat-option value="EMAIL">Email</mat-option>
                      </mat-select>
                    </mat-form-field>

                    @if (leadForm.get('contactPreference')?.value === 'TEXT') {
                      <mat-form-field appearance="outline">
                        <mat-label>Phone Number</mat-label>
                        <input matInput 
                               formControlName="phone" 
                               placeholder="(555) 123-4567" 
                               type="tel"
                               maxlength="14"
                               (input)="formatPhoneNumber($event)"
                               (keydown)="onPhoneKeyDown($event)">
                        <mat-icon matSuffix>phone</mat-icon>
                        <mat-error>
                          @if (leadForm.get('phone')?.touched && leadForm.get('phone')?.errors) {
                            {{ getErrorMessage('phone') }}
                          }
                        </mat-error>
                      </mat-form-field>
                    }

                    @if (leadForm.get('contactPreference')?.value === 'EMAIL') {
                      <mat-form-field appearance="outline">
                        <mat-label>Email Address</mat-label>
                        <input matInput formControlName="email" placeholder="Enter your email address" type="email">
                        <mat-icon matSuffix>email</mat-icon>
                        <mat-error>
                          @if (leadForm.get('email')?.touched && leadForm.get('email')?.errors) {
                            {{ getErrorMessage('email') }}
                          }
                        </mat-error>
                      </mat-form-field>
                    }
                  </div>

                  @if (leadForm.hasError('contactMethodRequired') && leadForm.touched) {
                    <div class="form-error">
                      {{ getErrorMessage('contact') }}
                    </div>
                  }

                  <div class="form-actions">
                    <button mat-raised-button type="submit" class="claim-btn" [disabled]="isSubmitting">
                      @if (isSubmitting) {
                        <mat-spinner diameter="20"></mat-spinner>
                      } @else {
                        <mat-icon>local_offer</mat-icon>
                      }
                      {{ isSubmitting ? 'Submitting...' : 'Claim 25% Discount' }}
                    </button>
                    
                    <div class="or-divider">
                      <span>or</span>
                    </div>
                    
                    <button mat-stroked-button type="button" class="call-btn" (click)="callPhone()">
                      <mat-icon>phone</mat-icon>
                      Call {{ config.phone.display }}
                    </button>
                  </div>
                </form>
              </mat-card-content>
            </mat-card>
          } @else {
            <mat-card class="success-card">
              <mat-card-content>
                <div class="success-message">
                  <mat-icon class="success-icon">check_circle</mat-icon>
                  <h2>Congratulations!</h2>
                  <p>You've successfully claimed your <strong>25% discount</strong> on your first 3 months!</p>
                  <p>We'll contact you soon to schedule your free inspection and discuss your pest control needs.</p>
                  <div class="offer-reminder">
                    <mat-icon>schedule</mat-icon>
                    <span>Remember: This offer expires April 30th, 2026</span>
                  </div>
                  <button mat-stroked-button class="call-btn" (click)="callPhone()">
                    <mat-icon>phone</mat-icon>
                    Call Now for Immediate Service
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Contact Info Footer -->
  <div class="contact-footer">
    <div class="container">
      <div class="contact-info">
        <div class="contact-item">
          <mat-icon>phone</mat-icon>
          <span>{{ config.phone.display }}</span>
        </div>
        <div class="contact-item">
          <mat-icon>email</mat-icon>
          <span>{{ config.email }}</span>
        </div>
        <div class="contact-item">
          <mat-icon>schedule</mat-icon>
          <span>{{ config.hours.weekdays }} | Sat: {{ config.hours.saturday }}</span>
        </div>
      </div>
    </div>
  </div>
</div>